/**
 * Feature flags with hardcoded defaults and PostHog overrides.
 *
 * Usage:
 *   Client: useFeatureFlag("enable_checks")
 *   Server: getServerFeatureFlag("enable_checks", userId)
 *
 * Flags are defined here with defaults. PostHog overrides are loaded
 * automatically on the client via the FeatureFlagProvider. On the server,
 * use the posthog-node client to evaluate flags per-user.
 *
 * To add a new flag: add it to FEATURE_FLAG_DEFAULTS below.
 */

/** All known feature flags and their default values. */
export const FEATURE_FLAG_DEFAULTS = {
  /** Master switch for the check (analysis) flow */
  enable_checks: true,
  /** Allow enrichment section unlocks */
  enable_enrichment_unlocks: true,
  /** Allow enrichment re-runs */
  enable_enrichment_reruns: true,
  /** Show the credit log on the account page */
  enable_credit_log: true,
  /** Show the neighborhood insights enrichment section */
  enable_neighborhood: true,
  /** Show the review digest enrichment section */
  enable_review_digest: true,
  /** Show the menu deep analysis enrichment section */
  enable_menu_deep: true,
  /** Show the review sentiment enrichment section */
  enable_review_sentiment: true,
  /** Show the platform verification enrichment section */
  enable_platform_verification: false,
} as const;

export type FeatureFlagName = keyof typeof FEATURE_FLAG_DEFAULTS;

/** Maps enrichment section keys to their feature flag. */
export const ENRICHMENT_SECTION_FLAGS: Record<string, FeatureFlagName> = {
  menu_deep: "enable_menu_deep",
  neighborhood: "enable_neighborhood",
  platform_verification: "enable_platform_verification",
  review_sentiment: "enable_review_sentiment",
  review_digest: "enable_review_digest",
};

export type FeatureFlagValues = Record<FeatureFlagName, boolean>;

/** Returns all defaults as a mutable record. */
export function getDefaults(): FeatureFlagValues {
  return { ...FEATURE_FLAG_DEFAULTS };
}
